export default __webpack_public_path__ + "static/media/expired-icon.8e9ab417.svg";